<template>

  <div>
    <!-- Filters -->
    <users-list-filters
      :status-filter.sync="statusFilter"
      :tipo-pessoa-filter.sync="tipoPessoaFilter"
      @statusFilter="updatedFilter"
      @tipoPessoaFilter="updatedFilter"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                v-if="$can('create', 'ADMIN_B2C')"
                variant="primary"
                @click="$router.push({ name: 'app-admin-add-cliente' })"
              >

                <span class="text-nowrap">
                  <feather-icon
                    class="cursor-pointer"
                    icon="PlusIcon"
                    size="16"
                  />
                  Cliente
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refGrupoListTable"
        class="position-relative"
        :items="fetchCleintes"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(documento)="data">
          <span class="text-nowrap">{{ maskCpfCnpj(data.item.documento) }}</span>
        </template>

        <template #cell(tipo_pessoa)="data">
          <span class="text-nowrap">{{ data.item.tipo_pessoa === 'F' ? 'Fisica' : 'Juridica' }}</span>
        </template>

        <!-- Column: User -->
        <template #cell(nome_cliente)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.nome_cliente)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
              />
            </template>
            <b-link
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.nome }}
            </b-link>
          </b-media>
        </template>

        <!-- Column: data_inclusao -->
        <template #cell(data_inclusao)="data">
          <span class="text-nowrap">{{ data.item.data_inclusao | formatDateTimeBr }}</span>
        </template>

        <!-- Column: Status -->
        <template #cell(ativo)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.ativo)}`"
            class="text-capitalize"
          >
            {{ data.item.ativo === 1 ? 'Ativo' : data.item.ativo === 0 ? 'Inativo' : 'Deletado' }}
          </b-badge>
        </template>
        <template #head(actions)="data">
          <span style="display: flex;justify-content: end">{{ data.label }}</span>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div
            class="row justify-content-end align-content-center"
            style="gap: 5px; flex-wrap: nowrap"
          >
            <feather-icon
              v-if="$can('read', 'CLIENTE_B2C')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Visualizar'"
              size="20"
              style="color: var(--secondary);"
              icon="EyeIcon"
              class="icon-activity"
              @click.stop="viewCliente(data.item.id)"
            />
            <feather-icon
              v-if="$can('update', 'CLIENTE_B2C')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Editar'"
              style="color: var(--info);"
              size="20"
              class="icon-activity"
              icon="EditIcon"
              @click.stop="editCliente(data.item.id)"
            />
            <feather-icon
              v-if="$can('delete', 'CLIENTE_B2C')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Deletar'"
              v-b-modal.modal-confirme-delete-cliente
              size="20"
              style="color: var(--danger);"
              icon="TrashIcon"
              class="icon-activity"
              @click.stop="idCliente = data.item.id"
            />
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
              dataMeta.of
            }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalClientes"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <ModalConfirm
      id-modal="modal-confirme-delete-cliente"
      title-modal="Excluir Grupo"
      label-btn-ok="Deletar"
      variant-label-btn-ok="danger"
      variant-label-btn-cancel="secondary"
      message="Deseja realmente excluir esse cliente?"
      @ok="deleteCategory"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, VBModal, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
  ref, onUnmounted, onMounted,
} from '@vue/composition-api'
import { avatarText, formatDateTimeBr } from '@core/utils/filter'
import ModalConfirm from '@/components/ModalConfirm.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import useClienteList from '@/views/apps/clientes/clientes-list/useClienteList'
import { maskCpfCnpj } from '@core/utils/utils'
import router from '@/router'
import UsersListFilters from './ClienteListFilters.vue'
import ClienteStoreModule from '../ClienteStoreModule'

export default {
  components: {
    UsersListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    ModalConfirm,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  filters: {
    formatDateTimeBr,
  },
  setup() {
    const toast = useToast()
    const USER_APP_STORE_MODULE_NAME = 'appAdmCliente'
    const blankCategoryData = ref({
      id: null,
      documento: '',
      tipo_pessoa: 'F',
      nome: '',
      ativo: 1,
    })
    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, ClienteStoreModule)
    const gruposOptions = ref([])
    onMounted(() => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchCleintes`)
    })

    const updatedFilter = () => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchCleintes`)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)
    const showAddEditUsuario = e => {
      isAddNewUserSidebarActive.value = e
    }

    const addCliente = async () => {
      blankCategoryData.value = {
        id: null,
        documento: '',
        tipo_pessoa: 'F',
        nome: '',
        ativo: 1,
      }
      isAddNewUserSidebarActive.value = true
    }

    const editCliente = async id => {
      router.push({ name: 'app-admin-edit-cliente', params: { id } })
    }

    const viewCliente = id => {
      router.push({ name: 'app-admin-view-cliente', params: { id } })
    }

    const {
      fetchCleintes,
      tableColumns,
      perPage,
      currentPage,
      totalClientes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      tipoPessoaFilter,
    } = useClienteList()
    const idCliente = ref(null)
    const deleteCategory = async () => {
      await store.dispatch(`${USER_APP_STORE_MODULE_NAME}/deleteCliente`, { id: idCliente.value })
        .then(resp => {
          toast({
            component: ToastificationContent,
            props: {
              title: resp.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          idCliente.value = null
          refetchData()
        })
      refetchData()
    }
    return {
      maskCpfCnpj,
      idCliente,
      addCliente,
      blankCategoryData,
      editCliente,
      showAddEditUsuario,
      gruposOptions,
      // Sidebar
      isAddNewUserSidebarActive,
      fetchCleintes,
      tableColumns,
      perPage,
      currentPage,
      totalClientes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      tipoPessoaFilter,
      updatedFilter,
      deleteCategory,
      viewCliente,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
